import React, { useContext } from 'react';
import { UnionPayStackRoutes, UnionPayStackScreenProps } from '@/features/bill-payment/screens/union-pay/type';
import { LayoutContext } from 'contexts/LayoutContext';
import { UnionPayRemittanceMobileComponent } from '@/features/bill-payment/screens/union-pay/UnionPayRemittanceMobile.component';
import { UnionPayRemittanceWebComponent } from '@/features/bill-payment/screens/union-pay/UnionPayRemittanceWeb.component';

export interface UnionPayRemittanceScreenProps {}

export const UnionPayRemittanceScreen: React.FC<UnionPayStackScreenProps<UnionPayStackRoutes.UnionPayRemittance>> = ({
  navigation,
  route
}) => {
  const layout = useContext(LayoutContext);
  const { onLayout, unionType, refresh, navigationNavigate, navigationScreen } = route.params;

  if (layout.isMobile) {
    return (
      <UnionPayRemittanceMobileComponent
        unionType={unionType}
        refresh={refresh}
        navigationNavigate={navigationNavigate}
        navigationScreen={navigationScreen}
      />
    );
  }
  return (
    <UnionPayRemittanceWebComponent
      onLayout={onLayout}
      unionType={unionType}
      refresh={refresh}
      navigationNavigate={navigationNavigate}
      navigationScreen={navigationScreen}
    />
  );
};
